var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"form-box"},[_c('table-grid',{attrs:{"table-name":_vm.tableName,"data-id":_vm.dataId,"grouping":_vm.grouping,"default-value":_vm.defaultValue},on:{"savecomplate":_vm.onClickLeft}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }